const SLABStrategy = Mach.requireModule('SLABStrategy');
const SLCompass = Mach.requireModule('SLCompass');

export function hitKeeta3UIRefreshStrategy(): boolean {
  return Boolean(SLABStrategy?.hitGlobalV3?.());
}

export function getCollectionPageMode(): 0 | 1 | 2 | undefined {
  let { region: compassRegion } = SLCompass?.getCompassInfo?.() || {};
  compassRegion = compassRegion ? compassRegion.toUpperCase() : '';
  const strategy = SLABStrategy?.getRealTimeStrategy?.({
    sceneKey: 'New_User_Discount_Login',
    groupKey: `New_User_Discount_Login_key_${compassRegion}`,
  });
  const strategyKey = strategy?.expKey ?? '';
  if (!strategyKey) {
    return 0;
  }
  if (strategyKey === 'A') {
    return 1;
  }
  if (strategyKey === 'B') {
    return 2;
  }
  return undefined;
}
